module.exports = __webpack_public_path__ + "img/tuya.df35bf39.png";